import { Box } from '@mui/material';
import UploadForm from './UploadForm';

const Attachments = ({policynum,policId, customerId}) => {
    return (
        <Box
            id="attachmentscontainer"
            name="attachmentsContainer"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
            }}
        >
            <UploadForm
                id="uploadformcomponent"
                name="uploadformcomponent"
                policynum={policynum}
                policId={policId}
                customerId={customerId}
            />
        </Box>
    );
};

export default Attachments;
